import React, { useState, useEffect, useContext } from 'react';
import { SolanaContext } from '../contexts/solanaContext';
import BackButton from './BackButton';
import BasicAnt from './images/BasicAnt.png';
import PremiumAnt from './images/ANT.png';
import Potion from './images/LevelingPotion.png';
import ChestCommon from './images/shop_img_chest_close_l_00.png';
import ChestUnCommon from './images/shop_img_chest_close_l_01.png';
import ChestRare from './images/shop_img_chest_close_l_02.png';
import ChestUltraRare from './images/shop_img_chest_close_l_03.png';
import ChestLegendary from './images/shop_img_chest_close_l_04.png';
import InventoryPremiumAnt from './InventoryPremiumAnt';
import InventoryBasicAnt from './InventoryBasicAnt';
import InventoryPurse from './InventoryPurse';
import InventoryLevelingpotion from './InventoryLevelingpotion';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';
import useFetchAllNfts from '../hooks/useFetchNfts';
import { useSelector } from 'react-redux';
import { selectAppBalances, selectAppNft } from '../store/appSlice';

function Inventory({ goBack, changeActiveComponent}) {
  const {lastFetched } = useSolanaWeb3();
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [selectedChestItemInfo, setSelectedChestItemInfo] = React.useState(null);
  const [selectedANTItem, setSelectedAntItem] = React.useState(null);
  const [selectedTab, setSelectedTab] = React.useState("ALL");
  const [activeItem, setActiveItem] = useState(null);
  const [, forceUpdate] = useState();
  const appStore = useSelector(selectAppBalances)
  const { nfts } = useSelector(selectAppNft)
  const chestTypes = [
    { balance: appStore.chestCommonBalance, image: ChestCommon, rarityClass: 'item-chest-common', categoryIndex: 0 },
    { balance: appStore.chestUnCommonBalance, image: ChestUnCommon, rarityClass: 'item-chest-uncommon', categoryIndex: 1 },
    { balance: appStore.chestRareBalance, image: ChestRare, rarityClass: 'item-chest-rare', categoryIndex: 2 },
    { balance: appStore.chestUltraRareBalance, image: ChestUltraRare, rarityClass: 'item-chest-ultrarare', categoryIndex: 3 },
    { balance: appStore.chestLegendaryBalance, image: ChestLegendary, rarityClass: 'item-chest-legendary', categoryIndex: 4 },
  ];
  

  const handleANTItemClick = (ant) => {
    setSelectedAntItem(ant);
    setActiveItem(ant.mint); // Store the unique identifier of the Ant
    setSelectedItem(ant.metadata.name.includes("Premium") ? 'premiumant' : 'basicant');
};

const handleItemClick = (itemName, itemInfo) => {
  setSelectedItem(itemName);
  setActiveItem(itemInfo.id); // Assign a unique ID for the item

  if (itemName === 'chest') {
      setSelectedChestItemInfo(itemInfo);
  } else {
      setSelectedAntItem(null);
  }
};

useEffect(() => {
  // This will force a re-render by changing the state.
  forceUpdate({});
}, [lastFetched, appStore.chestCommonBalance, appStore.chestUnCommonBalance, appStore.chestRareBalance, appStore.chestUltraRareBalance, appStore.chestLegendaryBalance, appStore.levelingPotionBalance]);

  return (
    <section id="nestwars">
      <div className="newui-container">
      <div className="platform-container">
        <div className="inventory-container">
          <div className="inventory-container-left">
            <div className="inventory-menu-buttons">
              <button onClick={() => setSelectedTab("ALL")}>ALL<div className={selectedTab === "ALL" ? "selected-divider" : ""}></div></button>
              <button onClick={() => setSelectedTab("ANTS")}>ANTS<div className={selectedTab === "ANTS" ? "selected-divider" : ""}></div></button>
              <button onClick={() => setSelectedTab("ITEMS")}>ITEMS<div className={selectedTab === "ITEMS" ? "selected-divider" : ""}></div></button>
            </div>
            <div className="inventory-items">
            {
  (selectedTab === "ALL" || selectedTab === "ITEMS") && (
    <div
      className={`inventory-item item-potion ${activeItem === 'levelingpotion' ? "active9" : ""}`} // Highlight active potion
      onClick={() => handleItemClick('levelingpotion', { id: 'levelingpotion' })} // Include unique identifier
    >
      <img src={Potion} alt="Leveling Potion" />
      <div className="inventory-item-texts">
        <p className="inventory-text">LEVELING POTION</p>
        <p className="inventory-level-text">QNT:</p>
        <p>{appStore.levelingPotionBalance?.toFixed(0)}</p>
      </div>
    </div>
  )
}
              {
  (selectedTab === "ALL" || selectedTab === "ANTS") &&
  nfts.map((nft, index) => {
    const isPremium = nft.metadata.name.includes("Premium");
    const antType = isPremium ? "PREMIUM" : "BASIC";

    return (
      <div
        key={index}
        className={`inventory-item ${isPremium ? "item-premium" : "item-basic"} ${activeItem === nft.mint ? "active9" : ""}`} // Highlight active Ant
        onClick={() => handleANTItemClick(nft)}
      >
        <img src={nft.metadata.image} alt={nft.metadata.name} />
        <div className="inventory-item-texts">
          <p className="inventory-text">WORKER ANT</p>
          <p className="inventory-level-text">LVL:</p>
          <p className="inventory-text">{nft.level}</p>
        </div>
      </div>
    );
  })
}
              {
                 (selectedTab === "ALL" || selectedTab === "ITEMS") &&
                 chestTypes.map((chest, index) => {
                   if (chest.balance > 0) {
                     return (
                      <div
                      className={`inventory-item ${chest.rarityClass} ${activeItem === chest.categoryIndex ? "active9" : ""}`}
                      onClick={() => handleItemClick('chest', { categoryIndex: chest.categoryIndex, id: chest.categoryIndex })} // Include ID when item is clicked
                  >
                      <img src={chest.image} alt="Chest" />
                      <div className="inventory-item-texts">
                          <p className="inventory-text">{chest.rarityClass.split('-').pop()} CHEST</p>
                          <p className="inventory-level-text">QNT:</p>
                          <p>{chest.balance}</p>
                      </div>
                  </div>
                     );
                   }
                   return null;
                 })
               }
            </div>
          </div>
          <div className="inventory-container-right" id="inventory-center">
            <h2 className="inventory-info-text">Choose any item to get more info about</h2>
          </div>
          {selectedANTItem && selectedItem === 'premiumant' && 
              <InventoryPremiumAnt 
                  key={selectedANTItem.mint} // Use a unique identifier
                  antInfo={selectedANTItem} 
                  changeActiveComponent={changeActiveComponent} 
                  onClose={() => setSelectedItem(null)} 
              />
          }
          {selectedANTItem && selectedItem === 'basicant' && 
              <InventoryBasicAnt 
                  key={selectedANTItem.mint} // Use a unique identifier
                  antInfo={selectedANTItem} 
                  changeActiveComponent={changeActiveComponent} 
                  onClose={() => setSelectedItem(null)} 
              />
          }
          {selectedItem === 'chest' && <InventoryPurse changeActiveComponent={changeActiveComponent} selectedChestItemInfo={selectedChestItemInfo}  onClose={() => setSelectedItem(null)} />}
          {selectedItem === 'levelingpotion' && <InventoryLevelingpotion levelingPotionBalance={appStore.levelingPotionBalance} changeActiveComponent={changeActiveComponent} onClose={() => setSelectedItem(null)} />}
        </div>
      </div>
      </div>
    </section>
  );
}

export default Inventory;